import FinsightSidebar, { IFinsightSidebar } from '@/creditflowresearch/ui/common/components/FinsightSidebar/FinsightSidebar';
import createFiltersStore from '@framework/ui/Organisms/Filters/createFiltersStore';
import { useFiltersContext } from '@framework/ui/Organisms/Filters/FiltersContext';
import { CFR_ARTICLES } from './constants';
import { initialArticlesFilterState } from '@/creditflowresearch/application/ArticlesAndStats/Articles/constants';
import { IMarketArticlesFilterPayload } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Articles/IMarketArticle';
import {
  useArticlesFilterContext,
} from '@/creditflowresearch/application/ArticlesAndStats/Articles/Filter/ArticlesFilterContext';
import SidebarDatePeriod from './Sections/SidebarDatePeriod';
import SidebarSections from './Sections/SidebarSections';
import SidebarTags from './Sections/SidebarTags';
import SidebarFooter from './Sections/SidebarFooter';
import { filtersKeys } from './Sections/constants';

const SidebarFilters = (props: IFinsightSidebar) => {
  const { getFilters } = useFiltersContext();
  const filters = getFilters(CFR_ARTICLES);

  const {
    state: { isFetching, appliedFilters, dateFromMin },
    applyFilter,
    fetchFilter,
    resetFilter,
    deals,
    parentIssuer,
  } = useArticlesFilterContext();

  const onFilterApply = async () => {
    await applyFilter();
    await fetchFilter();
  };

  const onResetFilters = async () => {
    await resetFilter();
    deals.setSelected([]);
    parentIssuer.setSelected([]);
  };

  return (
    <FinsightSidebar<IMarketArticlesFilterPayload, IMarketArticlesFilterPayload>
      { ...props }
      DatePeriodContainer={ SidebarDatePeriod }
      SectionsContainer={ SidebarSections }
      TagsContainer={ SidebarTags }
      FooterContainer={ SidebarFooter }
      filtersKeys={ filtersKeys }
      getFiltersInitialState={ () => initialArticlesFilterState }
      filters={ filters }
      isFetching={ isFetching }
      dateFromMin={ dateFromMin }
      appliedFilters={ appliedFilters }
      onFilterApply={ onFilterApply }
      resetFilters={ onResetFilters }
    />
  );
};

export default createFiltersStore({ filterName: CFR_ARTICLES })(SidebarFilters);
